import React, { useState, useEffect } from 'react'

import ColorPickerControl from 'components/ColorPicker/ColorPicker'

import './ColorPicker.scss'

const ColorPicker = ({ value, onUpdate }) => {
    const [currentValue, setCurrentValue] = useState(null)
    const [inputValue, setInputValue] = useState('')

    useEffect(() => {
        setCurrentValue(value)
        setInputValue(value || '')
    }, [value])

    const handleChangeComplete = color => {
        setCurrentValue(color.hex)
        onUpdate(color.hex)
    }

    const getHex = value => {
        const strVal = String(value)
        const hex = strVal[0] === '#' ? strVal : `#${strVal}`
        if (hex.match(/^#([0-9a-f]{3}){1,2}$/i)) return hex.toLowerCase()
        else return null
    }

    const onInputChange = evt => {
        setInputValue(evt.target.value)
        const hex = getHex(evt.target.value)
        if (hex) handleChangeComplete({ hex })
    }

    return (
        <div className="color-picker">
            <ColorPickerControl value={inputValue} onChange={v => handleChangeComplete({ hex: v })}>
                <div className="color-picker__edit-box">
                    <div className="color-picker__edit-box-preview" style={{ backgroundColor: currentValue }} />
                    <div className="color-picker__edit-box-input-container">
                        <input value={inputValue} spellCheck="false" onChange={onInputChange} />
                    </div>
                </div>
            </ColorPickerControl>
        </div>
    )
}

export default ColorPicker
